import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';

import { ApiService } from './../../shared/services/api.service';
import { EntityService } from './../../shared/services/entity.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { Contained } from './../../models/editors/contained.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';
import { Validators } from '@angular/forms';
import { ContainedMany } from './../../models/editors/contained-many.model';
import { Textarea } from './../../models/editors/textarea.model';
import { OfficeContact } from '../../models/office-contacts/office-contacts.model';
import { atLeastOneLang } from '../../shared/validators/langField.validator';
import { Dropdown } from './../../models/editors/dropdown.model';

import * as appConfig from './../../app.config';

@Component({
  selector: 'swb-office-contact-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class OfficeContactDetailComponent extends FormDetailBase<OfficeContact> implements OnInit {

  public entity = new OfficeContact({});

  public get fieldsConfig(): Array<any> {
    const langOptions = appConfig.languages.map(lang => { return { value: lang, text: lang }; });

    if (this.isModal) {
      return [
        new Dropdown({
          key: 'lang',
          label: 'Jazyk',
          validators: Validators.required,
          options: langOptions
        }),
        new Textbox({
          key: 'title',
          label: 'Název',
          validators: Validators.required
        }),
        new Textbox({
          key: 'person',
          label: 'Jméno osoby',
          validators: Validators.required
        }),
        new Textbox({
          key: 'job',
          label: 'Pozice osoby'
        }),
        new Textbox({
          key: 'phone',
          label: 'Telefon'
        }),
        new Textbox({
          key: 'email',
          type: 'email',
          label: 'E-mail',
          validators: [Validators.email]
        }),
        new Textarea({
          key: 'content',
          label: 'Vlastní text',
          wysiwyg: 'person-detail'
        })
      ];
    } else {
      return [
        new Dropdown({
          key: 'lang',
          label: 'Jazyk',
          validators: Validators.required,
          options: langOptions,
          defaultValue: langOptions[0].value
        }),
        new Textbox({
          key: 'title',
          label: 'Název',
          validators: Validators.required
        }),
        new Textbox({
          key: 'person',
          label: 'Jméno osoby',
          validators: Validators.required
        }),
        new Textbox({
          key: 'job',
          label: 'Pozice osoby'
        }),
        new Textbox({
          key: 'phone',
          label: 'Telefon'
        }),
        new Textbox({
          key: 'email',
          type: 'email',
          label: 'E-mail',
          validators: [Validators.email]
        }),
        new Textarea({
          key: 'content',
          label: 'Vlastní text',
          wysiwyg: 'person-detail'
        }),
        new Contained({
          key: 'file_id',
          label: 'Obrázek',
          upload: true,
          entity: this.entity.file
        }),
        new ContainedMany({
          key: 'offices',
          label: 'Pobočky',
          entities: this.entity.offices,
          upload: false,
          apiUrl: 'offices',
          canCreate: true
        })
      ];
    }
  }

  public url = 'office-contacts';

  protected _redirect = 'contacts';

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute,
    private _entityService: EntityService
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {

    if (typeof this._route.snapshot.params['id'] !== 'undefined' && this._route.snapshot.outlet !== 'modal-form') {
      this._id = this._route.snapshot.params['id'];
    }

    if (this._route.outlet === 'modal-form') {
      this.isModal = true;
      this._redirect = undefined;
      this._saveCallback = this._saveCallback = (response) => {
        const item = { ...response }.data;
        this._entityService.setChosenEntities([item], 'persons');
        this._closeCallback();
      };
      this._closeCallback = () => {
        this._router.navigate([{ outlets: { 'modal-form': null } }], {
          relativeTo: this._route.parent
        });
      };
      window.scrollTo(0, 0);
    }

    this._getEntity();

  }

}
